export const GET_CURRENT_NOVELS = 'GET_CURRENT_NOVELS';
export const GET_CURRENT_NOVELS_SUCCESS = 'GET_CURRENT_NOVELS_SUCCESS';
export const GET_CURRENT_NOVELS_FAILURE = 'GET_CURRENT_NOVELS_FAILURE';
// set index for current novel
export const SET_CURRENT_NOVEL_INDEX = "SET_CURRENT_NOVEL_INDEX";
